import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import CreditMemoAdmin from './CreditMemoAdmin';
import CreditMemoRequestAdmin from './CreditMemoRequestAdmin';

export default class CreditMemoParentAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  tab = this.urlParams.has('tab') ? parseInt(this.urlParams.get('tab')) : 0;
  clientInvoiceId = this.urlParams.has('ClientInvoiceId') ? parseInt(this.urlParams.get('ClientInvoiceId')) : 0;

  componentDidMount() {}

  tabs = [
    {
      label: 'Credit Memo',
      id: 'creditmemo',
      icon: 'fa-solid fa-credit-card',
      component: <CreditMemoAdmin clientInvoiceId={this.clientInvoiceId} />,
    },
    {
      label: 'Credit Memo Request',
      id: 'creditmemorequest',
      icon: 'fa-solid fa-memo-circle-info',
      component: <CreditMemoRequestAdmin clientInvoiceId={this.clientInvoiceId} />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage
              tabs={this.tabs}
              openOnTab={this.tab}
            />
          </div>
        </div>
      </div>
    );
  }
}
